import { createContext, useReducer, useCallback, FC, ReactNode } from 'react';
import useEventListener from '../hooks/useEventListener';
export interface EventsContext {
  doLogout: boolean;
  doCompleteRegistration: boolean;
}

export const EventsContext = createContext<EventsContext>({
  doLogout: false,
  doCompleteRegistration: false,
});

interface EventsProviderProps {
  children: ReactNode;
}

interface State {
  doLogout: boolean;
  doCompleteRegistration: boolean;
}

const initialState: State = {
  doLogout: false,
  doCompleteRegistration: false,
};

type LogoutEvent = {
  type: 'LOGOUT_EVENT';
};

type CompleteRegistrationEvent = {
  type: 'COMPLETE_REGISTRATION_EVENT';
};

type Action = LogoutEvent | CompleteRegistrationEvent;

const handlers: Record<string, (state: State, action: Action) => State> = {
  LOGOUT_EVENT: (state: State): State => ({
    ...state,
    doLogout: true,
  }),
  COMPLETE_REGISTRATION_EVENT: (state: State): State => ({
    ...state,
    doCompleteRegistration: true,
  }),
};

const reducer = (state: State, action: Action): State =>
  handlers[action.type] ? handlers[action.type](state, action) : state;

export const EventsProvider: FC<EventsProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const handleLogoutEvent = useCallback(() => {
    dispatch({ type: 'LOGOUT_EVENT' });
  }, []);

  const handleCompleteRegistrationEvent = useCallback(() => {
    dispatch({ type: 'COMPLETE_REGISTRATION_EVENT' });
  }, []);

  useEventListener('LOGOUT_EVENT', handleLogoutEvent);
  useEventListener('COMPLETE_REGISTRATION_EVENT', handleCompleteRegistrationEvent);
  return (
    <EventsContext.Provider
      value={{
        ...state,
      }}
    >
      {children}
    </EventsContext.Provider>
  );
};
